var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-numbers"},_vm._l((_vm.Numbers),function(n,key){return _c('div',{key:key,staticClass:"c-number"},[(n!=='*')?_c('img',{attrs:{"src":_vm.img(n)}}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }